const isLocal = process.env.NODE_ENV === 'development'
const LOCAL = 'http://localhost:8080/'
const REMOTE = 'https://play29-party-server-ikak5s2nra-uc.a.run.app/'
const host = isLocal ?  LOCAL : REMOTE 

export default {
    SERVER: host,
    API: host + 'api/'
}